import { RouteComponentProps } from '@reach/router';

import { AmazonParcelTable } from './AmazonParcelTable';

interface HubCountersParcelsProps extends RouteComponentProps {}

export const HubCountersParcels: React.FC<HubCountersParcelsProps> = () => {
  return <AmazonParcelTable showStats showHubCounterFilter syncUrl />;
};
